export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const CKEDITOR_UPLOAD_URL = process.env.REACT_APP_CKEDITOR_UPLOAD_URL;
